module.exports = __webpack_public_path__ + "img/txt_info4.a0e3140e.png";